export const openOrCloseModal = (value) => (value ? ({
  type: 'OPEN_MODAL',
}) : ({
  type: 'CLOSE_MODAL',
}));
